import React, { Component } from 'react'
import ReactResizeDetector from 'react-resize-detector';
import RoutingConstants from 'lib/RoutingConstants'
import { get } from 'lib/api'
import { getSelectedWeekDates, getWeekDays } from 'lib/services';
import Loader from 'lib/loader';
import DashHeader from '../dashboard/DashHeader';
import BillPayment from './BillPayment';
import ProfileBar from '../Profile/ProfileBar';
import history from '../../history'

class BillingInfo extends Component {
  constructor(props) {
    super(props)
    const dataProps = props.location ? props.location.state : {}
    const weekStartEnd = getSelectedWeekDates('currentWeek');
    const dayDates = dataProps ? dataProps.dayDates : getWeekDays(weekStartEnd);
        
    this.state = {
      subscriptionPlan: [],
      dayDates,
      ...dataProps,
      isMobile: false,
      loadData: false
    }
    window.scrollTo(0,0);
  }

  componentDidMount() {
    window.scrollTo(0,0);
    const dataProps = this.props.location ? this.props.location.state : {}
    if(dataProps && dataProps.path === 'billing') {
      this.getSubscription()
    } else if( dataProps &&  dataProps.path === 'dash');
    else {
      history.push('/dashboard')
    }
  }

  onResize() {
    window.scrollTo(0,0)
    if(window.innerWidth < 768) {
      this.setState({ isMobile: true })
    } else {
      this.setState({ isMobile: false })
    }
  }

  async getSubscription() {
    const url = RoutingConstants.getSubscriptionPlan;
    let { planId, planName, amount } = this.state
    this.setState({ loadData: true})
    await get(url).then((response) => {
      const result = response.result;
      if(result.length > 0) {
        planId = result[0].plan_id
        planName = result[0].plan_name
        amount = `$${parseFloat(result[0].total_price/100).toFixed(2)}`
      }
      this.setState({ subscriptionPlan: result, loadData: false, planName, planId, amount });
    }).catch(() => {
      // console.log('error', err);
    });
  }

  render() {
    const { dayDates, loadData } = this.state
    const startWeekMobileDate = `${dayDates[0].halfMonth} ${dayDates[0].date}`
    const endWeekMobileDate = `${dayDates[6].halfMonth} ${dayDates[6].date}`
    
    return(
      <div className="wrapper">
        <div className="mb-hide">
          <DashHeader
            dashClass={this.state.dashClass}
            groceryClass={this.state.groceryClass}
            dayDates={dayDates}
            // subscriptionPlan={subscriptionPlan}
            previous={this.state.previous}
            // planExist={planType}
            libraryClass="active"
          />
        </div>
        {
          loadData &&
          <div className="loading">
            <Loader />
            <div className="modal-backdrop fade in custm-bkdrp" />
          </div>
        }
        <ReactResizeDetector handleWidth handleHeight onResize={() => this.onResize()} />
        <div className="mobile-view-small mob-billing mb-only">
          <h2> Your Profile </h2>
          <div className="calndr-cntrls one-line">
            <a> 
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" />
              </svg>
            </a>
            
            <h3 className="mb-only">{startWeekMobileDate} - {endWeekMobileDate}</h3>
            <a >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
              </svg>
            </a>
          </div>
        </div>
        
        <section className="select-meal-cntnt plan_detl">
          <div className="mb-only"> 
            <ProfileBar value={2} />
          </div>
          <BillPayment {...this.state}/>
          <div className="billingBene">
            <div className="top-section">
              <div className="top-hdng">
                <h2> Join Today to Keep Your Benefits </h2>
                <ul>
                  <li> Access to all of your meal plans </li>
                  <li> Auto-created and customizable grocery lists </li>
                  <li> Healthy curated recipes </li>
                  <li> View recipes on any mobile, desktop device </li>
                  <li> Cancel anytime, no problem</li>
                </ul>
              </div>  
              <div className="faq">
                <h2>What’s the difference between the plans?</h2>
                <p>
                All Prep Day plans come with the same great benefits. 
                The only difference is that you save more by subscribing longer!
                </p>
              </div>
              <div className="faq">
                <h2>Can I cancel any time?</h2>
                <p>
                Yes, you can cancel at any time during your subscription. 
                We want your plan to work for you! Just email support@prepday.com.
                </p>
              </div>
            </div>
            <div className="bottom-section">
              <h2> What other preppers are Saying… </h2>
              <div className="usr-vws">
                <p>
                  I looked at my bank account after a month of using Prep Day and my jaw dropped. 
                  We used to eat out all the time because we were too tired at the end of the work day to cook.
                </p>
                <p className="usr-info">
                  <img src="/images/Wil.png" alt="user"/>
                  <span>Wil Pagod, Family of 2</span>
                </p>
              </div>
              <div className="usr-vws">
                <p>
                  I’m a Type 1 Diabetic and it’s overwhelming to plan meals, count carbs, 
                  make an organized grocery list and do all the cooking. 
                  Prep Day has made healthy eating a quick and easy process. 
                  I cook my meals in 1 day and have everything prepped for the week!
                </p>
                <p className="usr-info">
                  <img src="/images/Lori.png" alt="user"/>
                  <span>Lori Howell, Cooking for 1</span>
                </p>
              </div>
            
            </div>
          </div>
        </section>

      </div>
    )
  }
}

export default BillingInfo


// WEBPACK FOOTER //
// ./src/components/billingDetails/BillingInfo.js